import { usePatchRelaunchSegment } from '@/features/segments/api/patch-relaunch-segment';
import { TEnrichmentsSelection } from '@/features/segments/types';
import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';

export function useRelaunchCard() {
  const relaunchDialog = useDisclosureWithData<string>();
  const { mutate } = usePatchRelaunchSegment();

  const handleRelaunchSegment = async (id: string, enrichments: TEnrichmentsSelection) => {
    if (!id) return;
    mutate({ id, enrichments });
  };

  return {
    relaunchDialog,
    handleRelaunchSegment,
  };
}
